import { requestState, baseUrl, auth } from "./utils";
import axios from "axios";
import { showError } from "./error";
import {
    loadLandlordAnnouncements,
    clearLandlordData,
} from "./landlordActions";
import { clearTenantData } from "./tenantActions";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_BEARER_TOKEN = "SET_BEARER_TOKEN";
export const SET_USER_MATCHES = "SET_USER_MATCHES";
export const SET_USER_FAVORITE_MATCHES = "SET_USER_FAVORITE_MATCHES";
export const SET_FAVORITE_MATCH = "SET_FAVORITE_MATCH";
export const CLEAR_USER = "CLEAR_USER";
export const SET_MATCH_REQUEST_STATE = "SET_MATCH_REQUEST_STATE";
export const SET_FAVORITE_REQUEST_STATE = "SET_FAVORITE_REQUEST_STATE";
export const SET_SINGLE_MATCH = "SET_SINGLE_MATCH";
export const SET_SINGLE_MATCH_STATE = "SET_SINGLE_MATCH_STATE";
export const SET_USER_INTERESTS = "SET_USER_INTERESTS";
export const SET_INTEREST_REQUEST_STATE = "SET_INTEREST_REQUEST_STATE";
export const SET_USER_UPDATE_STATE = "SET_USER_UPDATE_STATE";
export const SET_EDITING_PROPERTIES = "SET_EDITING_PROPERTIES";
export const SET_EDITING_PROPERTIES_STATE = "SET_EDITING_PROPERTIES_STATE";
export const SET_PROPERTIES_UPDATE_STATE = "SET_PROPERTIES_UPDATE_STATE";
export const SET_PASSWORD_CHANGE_STATE = "SET_PASSWORD_CHANGE_STATE";
export const SET_PASSWORD_CHANGE_MESSAGE = "SET_PASSWORD_CHANGE_MESSAGE";

export function setUserData(data) {
    return {
        type: SET_USER_DATA,
        data: data,
    };
}

export function setBearerToken(token) {
    return {
        type: SET_BEARER_TOKEN,
        token: token,
    };
}

export function setUserMatches(matches) {
    return {
        type: SET_USER_MATCHES,
        matches: matches,
    };
}

export function setUserFavoriteMatches(matches) {
    return {
        type: SET_USER_FAVORITE_MATCHES,
        favoriteMatches: matches,
    };
}

export function setFavoriteMatch(id, favorite) {
    return {
        type: SET_FAVORITE_MATCH,
        id: id,
        favorite: favorite,
    };
}

export function setFavoriteState(state) {
    return {
        type: SET_FAVORITE_REQUEST_STATE,
        state: state,
    };
}

export function clearUserData() {
    return {
        type: CLEAR_USER,
    };
}

export function setMatchRequestState(state) {
    return {
        type: SET_MATCH_REQUEST_STATE,
        state: state,
    };
}

export function setSingleMatch(match) {
    return {
        type: SET_SINGLE_MATCH,
        match: match,
    };
}

export function setSingleMatchState(state) {
    return {
        type: SET_SINGLE_MATCH_STATE,
        state: state,
    };
}

export function setUserInterests(interests) {
    return {
        type: SET_USER_INTERESTS,
        interests: interests,
    };
}

export function setInterestRequestState(state) {
    return {
        type: SET_INTEREST_REQUEST_STATE,
        state: state,
    };
}

export function setUserUpdateState(state) {
    return {
        type: SET_USER_UPDATE_STATE,
        state: state,
    };
}

export function setEditingProperties(properties) {
    return {
        type: SET_EDITING_PROPERTIES,
        properties: properties,
    };
}

export function setEditingPropertiesState(state) {
    return {
        type: SET_EDITING_PROPERTIES_STATE,
        state: state,
    };
}

export function setPropertiesUpdateState(state) {
    return {
        type: SET_PROPERTIES_UPDATE_STATE,
        state: state,
    };
}

export function setPasswordChangeState(state) {
    return {
        type: SET_PASSWORD_CHANGE_STATE,
        state: state,
    };
}

export function setPasswordChangeMessage(message) {
    return {
        type: SET_PASSWORD_CHANGE_MESSAGE,
        message: message,
    };
}

export function loadMatches() {
    return async (dispatch, getState) => {
        dispatch(setMatchRequestState(requestState.inProgress));
        try {
            const user = getState().user.data;

            let res;

            if (user.isLandlord) {
                // const announcement = getCurrentAnnouncement( getState() );
                const announcementId = getState().landlord.selectedAnnouncement;
                if (announcementId === undefined) {
                    dispatch(setMatchRequestState(requestState.fail));
                    return;
                }
                res = await axios.post(
                    `${baseUrl}/matchmaking?all=true`,
                    {
                        announcement: announcementId,
                    },
                    auth(getState)
                );
                console.log("POST /matchmaking?all=true response:", res); // DEBUG
            } else {
                const properties = user.properties[0];
                if (properties === undefined) {
                    dispatch(setMatchRequestState(requestState.fail));
                    return;
                }
                res = await axios.post(
                    `${baseUrl}/matchmaking?favorite=false`,
                    {
                        property: properties.id,
                    },
                    auth(getState)
                );
                console.log("POST /matchmaking?favorite=false response:", res); // DEBUG
            }

            const matches = [...res.data];
            dispatch(setMatchRequestState(requestState.ok));
            dispatch(setUserMatches(matches.filter(m => m))); // Filters out null matches
            return res;
        } catch (e) {
            dispatch(setMatchRequestState(requestState.fail));
            dispatch(showError(e.response.data.message));
        }
    };
}

export function loadInterests(announcementId) {
    return async (dispatch, getState) => {
        try {
            dispatch(setInterestRequestState(requestState.inProgress));
            const user = getState().user.data;
            if (user.properties && user.properties.length === 0) {
                dispatch(showError("No user properties"));
                dispatch(setInterestRequestState(requestState.fail));
                return;
            }
            if (user.isLandlord !== true) {
                const res = await axios.get(
                    `${baseUrl}/user/${user.id}/favorites?interested=true`,
                    auth(getState)
                );
                console.log(
                    `GET /user/${user.id}/favorites?interested=true response:`,
                    res,
                    user
                ); // DEBUG
                const resultInterests = await Promise.all(
                    res.data[0].isInterested.map(async interest => {
                        const r = await axios.post(
                            `${baseUrl}/matchmaking?specific=true`,
                            {
                                announcement: interest,
                                property: user.properties[0].id,
                            },
                            auth(getState)
                        );
                        return r.data;
                    })
                );
                dispatch(setUserInterests(resultInterests));
                dispatch(setInterestRequestState(requestState.ok));
            } else {
                const announcement = await axios.get(
                    `${baseUrl}/announcement/${announcementId}`,
                    auth(getState)
                );
                console.log(
                    `GET /user/${user.id}/favorites?interested=true response:`,
                    announcement
                ); // DEBUG
                const resultInterests = await Promise.all(
                    announcement.data.isInterested.map(async interest => {
                        const res = await axios.post(
                            `${baseUrl}/matchmaking?specific=true`,
                            {
                                announcement: announcement.data,
                                property: interest.properties[0].id,
                            },
                            auth(getState)
                        );
                        return res.data;
                    })
                );
                dispatch(setUserInterests(resultInterests));
                dispatch(setInterestRequestState(requestState.ok));
            }
        } catch (error) {
            console.log(error);
            dispatch(showError(error.response.data.message));
            console.log("loadInterests - error", error);
            dispatch(setInterestRequestState(requestState.fail));
        }
    };
}

export function getFavorites() {
    return async (dispatch, getState) => {
        try {
            dispatch(setFavoriteState(requestState.inProgress));
            const user = getState().user.data;
            if (user === undefined) {
                return;
            }
            const res = await axios.get(
                `${baseUrl}/user/${user.id}/favorites`,
                auth(getState)
            );
            let favorites = await Promise.all(
                res.data[0].favorites.map(async favorite => {
                    const res = await axios.post(
                        `${baseUrl}/matchmaking?favorite=true`,
                        {
                            favorite,
                            property: user.properties[0].id,
                        },
                        auth(getState)
                    );
                    return res.data;
                })
            );
            dispatch(setFavoriteState(requestState.ok));
            dispatch(setUserData(user)); // TODO: Remove
            dispatch(
                setUserFavoriteMatches(
                    (await favorites.length) > 0 ? await favorites[0].data : []
                )
            ); // TODO: Remove
            return [...favorites]; // TODO: Remove
        } catch (error) {
            dispatch(setFavoriteState(requestState.fail));
            dispatch(showError(error.response.data.message));
            console.log(error);
        }
    };
}

export function setFavorite(id, favorite) {
    return (dispatch, getState) => {
        const isLandlord =
            getState().user.data && getState().user.data.isLandlord;
        const user = getState().user;
        if (isLandlord) {
            if (favorite === false) {
                axios
                    .delete(
                        `${baseUrl}/user/${user.data.id}/interested/${id}`,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/interested/${id} response:`,
                            response
                        ); // DEBUG
                        dispatch(loadMatches());
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/interested/${id} error:`,
                            error
                        ); // DEBUG
                    });
                dispatch(setFavoriteMatch(id, favorite)); // Handle the client side toggling
            } else {
                axios
                    .post(
                        `${baseUrl}/user/${user.data.id}/interested/${id}`,
                        null,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/interested/${id} response:`,
                            response
                        ); // DEBUG
                        dispatch(loadMatches());
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/interested/${id} error:`,
                            error
                        ); // DEBUG
                    });
                dispatch(setFavoriteMatch(id, favorite)); // Handle the client side toggling
            }
        } else {
            if (favorite === false) {
                axios
                    .delete(
                        `${baseUrl}/user/${user.data.id}/favorite/${id}`,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/favorite/${id} response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/favorite/${id} error:`,
                            error
                        ); // DEBUG
                    });
                dispatch(setFavoriteMatch(id, favorite)); // Handle the client side toggling
            } else {
                axios
                    .post(
                        `${baseUrl}/user/${user.data.id}/favorite/${id}`,
                        null,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/favorite/${id} response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `POST /user/${user.data.id}/favorite/${id} error:`,
                            error
                        ); // DEBUG
                    });
                dispatch(setFavoriteMatch(id, favorite)); // Handle the client side toggling
            }
        }
    };
}

export function setInterested(id, interested) {
    return (dispatch, getState) => {
        const isLandlord =
            getState().user.data && getState().user.data.isLandlord;
        const user = getState().user;
        if (isLandlord) {
            if (interested === false) {
                axios
                    .delete(
                        `${baseUrl}/user/${user.data.id}/interested/${id}`,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/interested/${id} response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/interested/${id} error:`,
                            error
                        ); // DEBUG
                    });
                // dispatch( setFavoriteMatch( id, interested ) ); // Handle the client side toggling
            } else {
                axios
                    .post(
                        `${baseUrl}/user/${user.data.id}/interested/${id}`,
                        null,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/interested/${id} response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/interested/${id} error:`,
                            error
                        ); // DEBUG
                    });
                // dispatch( setFavoriteMatch( id, interested ) ); // Handle the client side toggling
            }
        } else {
            if (interested === false) {
                axios
                    .delete(
                        `${baseUrl}/user/${
                            user.data.id
                        }/favorite/${id}?interested=true`,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/favorite/${id}?interested=true response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `DELETE /user/${
                                user.data.id
                            }/favorite/${id}?interested=true error:`,
                            error
                        ); // DEBUG
                    });
                // dispatch( setFavoriteMatch( id, interested ) ); // Handle the client side toggling
            } else {
                axios
                    .post(
                        `${baseUrl}/user/${
                            user.data.id
                        }/favorite/${id}?interested=true`,
                        null,
                        auth(getState)
                    )
                    .then(response => {
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/favorite/${id}?interested=true response:`,
                            response
                        ); // DEBUG
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(
                            `POST /user/${
                                user.data.id
                            }/favorite/${id}?interested=true error:`,
                            error
                        ); // DEBUG
                    });
                // dispatch( setFavoriteMatch( id, interested ) ); // Handle the client side toggling
            }
        }
    };
}

export function setProfilePic(file) {
    return (dispatch, getState) => {
        let formData = new FormData();
        const userId = getState().user.data.id;
        formData.append("file", file);
        axios
            .post(`${baseUrl}/files`, formData, auth(getState))
            .then(response => {
                console.log(`POST? /files response:`, response); // DEBUG
                const id = response.data.id;
                axios
                    .patch(
                        `${baseUrl}/user/${userId}`,
                        { file: id },
                        auth(getState)
                    )
                    .then(patchResponse => {
                        console.log(
                            `PATCH /user/${userId} response:`,
                            patchResponse
                        ); // DEBUG
                        dispatch(reloadUser());
                    })
                    .catch(error => {
                        dispatch(showError(error.response.data.message));
                        console.log(`PATCH /user/${userId} error:`, error); // DEBUG
                    });
            })
            .catch(error => {
                dispatch(showError(error.response.data.message));
                console.log(`POST? /files error:`, error); // DEBUG
            });
    };
}

export function getSingleMatch(annoId, propId) {
    return async (dispatch, getState) => {
        try {
            const user = getState().user.data;

            if (user.isLandlord) {
                dispatch(setSingleMatchState(requestState.inProgress));
                if (
                    getState().landlord.announcementState === requestState.none
                ) {
                    await dispatch(loadLandlordAnnouncements());
                }
                const ownAnnouncement = getState().landlord.announcements.find(
                    anno => anno.id === annoId
                );
                const body = {
                    property: propId,
                    announcement: ownAnnouncement,
                };
                const props = await axios.get(
                    `${baseUrl}/properties/${propId}`,
                    auth(getState)
                );
                console.log(`GET /properties/${propId} response`, props.data);
                const res = await axios.post(
                    `${baseUrl}/matchmaking?specific=true`,
                    body,
                    auth(getState)
                );
                console.log(`POST /matchmaking?specific=true response:`, res); // DEBUG
                dispatch(
                    setSingleMatch({
                        ...res.data,
                        tenant: {
                            user: props.data.user,
                            properties: { ...props.data },
                        },
                    })
                );
                dispatch(setSingleMatchState(requestState.ok));
            } else {
                dispatch(setSingleMatchState(requestState.inProgress));
                const annoRes = await axios.get(
                    `${baseUrl}/announcement/${annoId}`,
                    auth(getState)
                );
                console.log(`GET /announcement/${annoId} response:`, annoRes); // DEBUG
                const anno = {
                    favors: [],
                    ...annoRes.data,
                };
                const ownProperty = user.properties[0];
                // const ownProperty = user.properties[0];
                const body = {
                    property: ownProperty.id,
                    favorite: anno,
                };
                const res = await axios.post(
                    `${baseUrl}/matchmaking?favorite=true`,
                    body,
                    auth(getState)
                );
                console.log(`POST /matchmaking?favorite=true response:`, res); // DEBUG
                dispatch(setSingleMatch(res.data));
                dispatch(setSingleMatchState(requestState.ok));
            }
        } catch (error) {
            dispatch(setSingleMatchState(requestState.fail));
            console.log("getSingleMatch error:", error);
            dispatch(showError(error.response.data.message));
        }
    };
}

export function logout() {
    return async (dispatch, getState) => {
        try {
            await axios.delete(`${baseUrl}/bearers`, auth(getState));
        } catch (error) {
            console.log("logout() - error:", error); // DEBUG
        } finally {
            dispatch(clearUserData());
            dispatch(clearLandlordData());
            dispatch(clearTenantData());
        }
    };
}

export function updateUser(values) {
    return async (dispatch, getState) => {
        try {
            dispatch(setUserUpdateState(requestState.inProgress));
            const user = getState().user.data;
            const res = await axios.patch(
                `${baseUrl}/user/${user.id}`,
                values,
                auth(getState)
            );
            console.log(`PATCH /user/${user.id} result:`, res); // DEBUG
            dispatch(setUserUpdateState(requestState.ok));
            dispatch(
                setUserData({
                    ...user,
                    ...values,
                })
            );
        } catch (error) {
            dispatch(setUserUpdateState(requestState.fail));
            console.log("updateUser - error:", error);
        }
    };
}

export function updateUserTenant(values, isPrivateTenant) {
    return async (dispatch, getState) => {
        try {
            dispatch(setUserUpdateState(requestState.inProgress));
            const user = getState().user.data;
            const res = await axios.patch(
                `${baseUrl}/user/${user.id}/tenant`,
                values,
                auth(getState)
            );
            dispatch(setUserUpdateState(requestState.ok));
            const tenantKey = isPrivateTenant
                ? "privateTenant"
                : "organizationTenant";
            dispatch(
                setUserData({
                    ...user,
                    [tenantKey]: {
                        ...user[tenantKey],
                        ...values,
                    },
                })
            );
        } catch (error) {
            dispatch(setUserUpdateState(requestState.fail));
            console.log("updateUser - error:", error);
        }
    };
}

export function getEditingProperties(propId) {
    return async (dispatch, getState) => {
        try {
            dispatch(setEditingPropertiesState(requestState.inProgress));
            const res = await axios.get(
                `${baseUrl}/properties/${propId}`,
                auth(getState)
            );
            console.log(`GET /properties/${propId} response:`, res); // DEBUG
            dispatch(setEditingProperties(res.data));
            dispatch(setEditingPropertiesState(requestState.ok));
        } catch (error) {
            dispatch(setEditingPropertiesState(requestState.fail));
            console.log("getEditingProperties - error:", error);
        }
    };
}

export function updateProperties(propId, values) {
    return async (dispatch, getState) => {
        try {
            dispatch(setPropertiesUpdateState(requestState.inProgress));
            const user = getState().user.data;
            const res = await axios.patch(
                `${baseUrl}/properties/${propId}`,
                values,
                auth(getState)
            );
            console.log(`PATCH /properties/${propId} result:`, res); // DEBUG
            dispatch(setPropertiesUpdateState(requestState.ok));
            if (user.isLandlord) {
                dispatch(loadLandlordAnnouncements());
            } else {
                dispatch(
                    setUserData({
                        ...user,
                        properties: [
                            {
                                ...user.properties[0],
                                ...values,
                            },
                        ],
                    })
                );
            }
        } catch (error) {
            dispatch(setPropertiesUpdateState(requestState.fail));
            console.log("updateProperties - error:", error);
        }
    };
}

export function reloadUser() {
    return async (dispatch, getState) => {
        try {
            const currentUser = getState().user;
            const newUserData = await axios.get(
                `${baseUrl}/user/${currentUser.data.id}`,
                auth(getState)
            );
            console.log(
                `GET /user/${currentUser.data.id} response:`,
                newUserData
            );
            const data = {
                ...currentUser.data,
                ...newUserData.data,
            };
            dispatch(setUserData(data));
        } catch (error) {
            console.log("reloadUser - error:", error);
        }
    };
}

export function confirmToken() {
    return async (dispatch, getState) => {
        try {
            if (getState().user.bearerToken === undefined) return;
            console.log("CONFIRMING TOKEN..."); // DEBUG
            const res = await axios.get(`${baseUrl}/bearers`, auth(getState));
            console.log("[:::TOKEN CONFIFMATION:::]", res.statusText); // DEBUG
        } catch (error) {
            console.log(
                `[:::TOKEN CONFIFMATION:::] ${error.response.statusText} : ${
                    error.response.data.message
                }`
            );
            dispatch(logout());
            // console.log( "confirmToken() - error:", error );
            // dispatch( showError( error.response.data.message ) );
        }
    };
}

async function confirmLogin(login) {
    try {
        const res = await axios.post(`${baseUrl}/bearers`, login); // Try to login
        await axios.delete(`${baseUrl}/bearers`, {
            headers: { bearer: res.data.bearer },
        }); // If successful, delete the just created token
        return true;
    } catch {
        return false;
    }
}

export function changePassword(oldPassword, newPassword) {
    return async (dispatch, getState) => {
        try {
            dispatch(setPasswordChangeState(requestState.inProgress));
            dispatch(setPasswordChangeMessage(""));
            const user = getState().user.data;
            const login = {
                email: user.email,
                password: oldPassword,
            };
            const confirmed = await confirmLogin(login);
            if (!confirmed) {
                dispatch(setPasswordChangeState(requestState.fail));
                dispatch(
                    setPasswordChangeMessage("Old password was incorrect.")
                );
                return;
            }
            await axios.patch(
                `${baseUrl}/user/${user.id}`,
                { password: newPassword },
                auth(getState)
            );
            dispatch(setPasswordChangeState(requestState.ok));
            dispatch(setPasswordChangeMessage("Password changed."));
        } catch {
            dispatch(setPasswordChangeState(requestState.fail));
            dispatch(
                setPasswordChangeMessage("Password change was not successful.")
            );
        }
    };
}
